import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject } from '@angular/core';
import { ApplicationStore } from '../../../../core/services/application-store.service';
import { SignatureEnum } from '../contract-response.model';
import { PaperDeliveryComponent } from './paper-delivery/paper-delivery.component';
import { DematDeliveryComponent } from './demat-delivery/demat-delivery.component';
import { LoaderComponent, NoValue } from '@tribeauto/ngx-mobilite-material';

@Component({
  selector: 'pvmo-delivery',
  imports: [PaperDeliveryComponent, DematDeliveryComponent, LoaderComponent],
  templateUrl: './delivery.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliveryComponent {
  private readonly applicationStore = inject(ApplicationStore);
  private readonly cdr = inject(ChangeDetectorRef);

  signatureData = this.applicationStore.instant('signatureData');
  _signatureType: SignatureEnum | NoValue;
  isLoading = true;
  isPaperDelivery = false;
  isDematDelivery = false;

  constructor() {
    effect(() => {
      this._signatureType = this.signatureData()?.signatureType;
      this.setDeliveryType();
    });
  }

  setDeliveryType(): void {
    if (this._signatureType) {
      this.isPaperDelivery = [SignatureEnum.VAD, SignatureEnum.PAPER, SignatureEnum.DEMAT, SignatureEnum.FAF].includes(
        this._signatureType
      );
      this.isDematDelivery = [
        SignatureEnum.AD_DELIVERY,
        SignatureEnum.VAD_DELIVERY,
        SignatureEnum.FAF_DELIVERY
      ].includes(this._signatureType);
    }
    this.isLoading = false;
    this.cdr.markForCheck();
  }
}
